<ng-template #assignedGivi let-modal>
    <div *ngIf="!isGiver" class="text-center" style="padding: 40px 20px;">
        <div class="font-20 font-bold">¡Givi Asignado!</div>
        <div class="font-14 text-muted">Podés canjearlo o regalarlo desde la sección de ¨Mis Givis¨</div>
        <div style="margin-top: -20px; margin-bottom: -30px;">
            <iframe src="https://lottie.host/embed/a5d5d18c-7e97-43ca-b1cd-be983fad83f5/D945dtbA1a.lottie" frameborder="0" width="100%" height="200"></iframe>
        </div>
        <!-- progress-bar -->
        <div class="d-flex-center" (click)="onGoToGivis()">
            <div class="progress-bar-container">
                <div class="progress-bar" [style.width]="progress + '%'"></div>
                <div class="progress-content">
                    <img src="assets/images/iconomisgivis.png" width="25px">
                    <span class="font-16 ml-2">Ir a Mis Givis</span>
                </div>
            </div>
        </div>
        <div class="font-12 font-bold mt-1">{{secondsElapsed}} seg</div>
        <div class="font-14 font-bold text-muted m-t-10" (click)="onClose()">Volver al App</div>
    </div>
    <div *ngIf="isGiver" class="text-center" style="padding: 40px 20px;">
        <div class="font-20 font-bold">¡La donación se realizó correctamente!</div>
        <div class="font-14 text-muted">Podés ver el detalle en transacciones de tu perfil</div>
        <div class="d-flex-center">
            <img src="assets/images/Danoaciones-min.gif" style="width: 190px;">
        </div>
        <div class="font-14 font-bold text-muted m-t-40" (click)="onClose()">Volver al App</div>
    </div>
</ng-template>